import { render, staticRenderFns } from "./CurrentDeliveries.vue?vue&type=template&id=f77de66e&"
import script from "./CurrentDeliveries.vue?vue&type=script&lang=js&"
export * from "./CurrentDeliveries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports